<template>
    <div>
        <dashboard-slider></dashboard-slider>
        <div class="main-layout">
            <div class="tap px-2 mt-3">
                <div class="tab-list">
                    <div class="tab-item" @click="goto('privilege')">
                        แลกของรางวัล
                    </div>
                    <div
                        class="tab-item active"
                        @click="goto('privilegeluckydraw')"
                    >
                        ลุ้นรางวัล
                    </div>
                </div>
                <div>
                    <campaign-list
                        class="mt-3"
                        :lbl="lbl"
                        :isLoading="isLoading"
                        :initListConfig="campaignListConfig"
                        :initFilterConfig="campaginListFilterConfig"
                        :busEvent="busCategory"
                        @toggleLoading="toggleLoading($event)"
                    >
                    </campaign-list>
                </div>
            </div>
        </div>
        <Footer :settabactive="'privilege'" />
        <div>
            <b-modal
                id="modalTerm"
                modal-class="modal-list-address"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="modal-base">
                    <div class="modal-base-body pb-4">
                        <Terms />
                    </div>
                </div>
                <div class="modal-base-footer text-center">
                    <div>
                        <button
                            class="btn btn-close-pdpa"
                            @click="$bvModal.hide('modalTerm')"
                        >
                            ปิด
                        </button>
                        <button
                            class="btn btn-submit-pdpa-regis"
                            @click="updateVersionTermPdpa()"
                        >
                            ยอมรับ
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>
        <div>
            <b-modal
                id="modalPDPA"
                modal-class="modal-list-address"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
            >
                <div class="modal-base">
                    <div class="modal-base-body pb-4">
                        <Pdpa />
                    </div>
                </div>
                <div class="modal-base-footer text-center">
                    <div>
                        <button
                            class="btn btn-close-pdpa"
                            @click="$bvModal.hide('modalPDPA')"
                        >
                            ปิด
                        </button>
                        <button
                            class="btn btn-submit-pdpa-regis"
                            @click="updateVersionTermPdpa()"
                        >
                            ยอมรับ
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
// helper
import Locale from "@/helper/locale/locale.js";
import DashboardSlider from "@/components/Dashboard/DashboardSlider.vue";
// core
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import ConfigManager from "@/config/ConfigManager.js";
// component
import CampaignList from "../component/CampaignListDraw.vue";
import Footer from "@/components/Footer/Footer.vue";
import CheckLogin from "@/mixin/CheckLogin.js";
import Terms from "@/module/Static/page/Terms.vue";
import Pdpa from "@/components/PDPA/Page/PDPA.vue";
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
import CacheHelper from "@/helper/CacheHelper.js";

export default {
    name: "Category",
    components: {
        CampaignList,
        Footer,
        DashboardSlider,
        Terms,
        Pdpa
    },
    mixins: [CheckLogin],
    data: function() {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            isLoading: false,
            //config
            categoryConfig: {},
            campaignListConfig: {},
            campaginListFilterConfig: {},
            //bus
            busCategory: new Vue(),
            tab: "rewards",
            pdpaTermVersion: {},
            cacheHelper: new CacheHelper(),
            consent: {},
            tokenbzbs: null
        };
    },
    watch: {
        activeTab: function(newItem) {
            this.clickTab(newItem);
        }
    },
    mounted() {
        var cacheHelper = new CacheHelper("cookie");
        this.tokenbzbs = cacheHelper.getCache("BzbsUser").token;
        // this.apiGetPdpaTermsVersion();
        // this.getConsent();
    },
    created: function() {
        this.initialCategory();
        window._lt(
            "send",
            "cv",
            {
                type: "RedeemPageView"
            },
            ["2360d21e-79ce-4697-9bc0-02f5f2555aef"]
        );

        window.fbq("trackCustom", "RedeemPageView");

        window.gtag("event", "conversion", {
            send_to: "AW-970877309/ItxYCPyF_qUDEP3S-c4D"
        });
    },
    methods: {
        apiGetPdpaTermsVersion: function() {
            BzbsPDPA.apiGetPDPAVersion().subscribe(
                data => {
                    this.pdpaTermVersion = data;
                    console.log(data);
                },
                err => {
                    this.errorResponse(err);
                }
            );
        },
        updateVersionTermPdpa() {
            BzbsPDPA.apiPostConsent(
                this.tokenbzbs,
                this.pdpaTermVersion.terms.current_version,
                this.pdpaTermVersion.privacy.current_version
            ).subscribe(
                res => {
                    console.log("res", res);
                    this.$bvModal.hide("modalPDPA");
                    this.$bvModal.hide("modalTerm");
                },
                err => {
                    console.log("apiPostTermPDPAVersion error", err);
                }
            );
        },
        getConsent: function() {
            BzbsPDPA.apiGetConsent(this.tokenbzbs).subscribe(
                data => {
                    this.consent = data;
                    console.log(data);
                    if (
                        this.pdpaTermVersion.terms.current_version !=
                        data.TermAndCondition
                    ) {
                        setTimeout(() => {
                            this.$bvModal.show("modalTerm");
                            console.log(
                                this.pdpaTermVersion.terms.current_version,
                                this.consent.TermAndCondition,
                                "term"
                            );
                        }, 1000);
                    }
                    if (
                        this.pdpaTermVersion.privacy.current_version !=
                        data.DataPrivacy
                    ) {
                        setTimeout(() => {
                            this.$bvModal.show("modalPDPA");
                            console.log(
                                this.pdpaTermVersion.privacy.current_version,
                                this.consent.DataPrivacy,
                                "pdpa"
                            );
                        }, 1000);
                    }
                },
                err => {
                    this.errorResponse(err);
                }
            );
        },
        changeCategory: function(category) {
            this.initialCampaign(category);
        },
        initialCategory: function() {
            var configStr = ConfigManager.getCategoryMenu();
            console.log(configStr, "configStr");
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig("menu_suntory_luckydraw")
                .setLocale(this.locale);

            this.categoryConfig = categoryConfig.create();
        },
        initialCampaign: function(category) {
            this.campaignListConfig = {};
            this.campaginListFilterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(category.list_config)
                .setTop(25);

            if (category.id) listConfig.setCatId(category.id);

            this.campaignListConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();
            this.campaginListFilterConfig = filterConfig.create();

            this.busCategory.$emit("reInitList", {
                listConfig: this.campaignListConfig,
                filterConfig: this.campaginListFilterConfig
            });
        },
        toggleLoading: function(isLoading) {
            this.isLoading = isLoading;
        },
        clickTab: function(tab) {
            this.tab = tab;
            this.$emit("clickTab", this.tab);
        },
        goto(page) {
            this.$router.push("/" + page);
        }
    }
};
</script>
<style lang="scss">
.list-category {
    .owl-nav {
        display: none;
    }
    .owl-dots {
        display: none;
    }
}
.tab-list {
    display: flex;
    font-size: 1.5rem;
    border: solid 1px #f25228;
    border-radius: 28px;
    background: #fff;
    .tab-item {
        font-family: "PromptSemiBold";
        background: #fff;
        color: #f25228;
        padding: 5px 10px;
        text-align: center;
        // ellipsis text
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        line-height: 23px;
        height: auto;
        &.active {
            background: #f25228;
            color: #fff;
        }

        &:first-child {
            border-radius: 30px;
        }
        &:last-child {
            border-radius: 30px;
        }
    }
}
.not-campaign {
    font-size: 16px;
}
.position-btn-close-regis {
    z-index: 2;
    position: absolute;
    // top: 50%;
    left: 6%;
    transform: translate(0%, -100%);
}
.position-img-blur {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 0;
}
.btn-register {
    width: 100%;
    border-radius: 25px;
    background: #6ba73c;
    border-color: #6ba73c;
    height: 45px;
    color: #fff;
    font-size: 16px;
    padding: 0;
    font-family: "PromptSemiBold";
}
.btn-register:hover {
    width: 100%;
    border-radius: 25px;
    background: #6ba73c;
    border-color: #6ba73c;
    height: 45px;
    color: #fff;
    font-size: 16px;
    padding: 0;
}

.w-167 {
    width: 167px;
}
</style>
